import {Meta} from "./meta";
import {Arquivo} from "./arquivo";
import {Setor} from "./setor";

export class Projeto {
    id: number = -1;
    nome: string = "";
    numeroIgesp: string = "";
    ano: number = -1;
    valorTotal: number = -1;
    pcContrapartida: number = -1;
    pcExecutado?: number = -1;
    valorContrapartida: number = -1;
    fonteRecurso: string = "";
    convenio: string = "";
    contaBancaria: string = "";
    dataInicio: Date | undefined;
    dataLimite: Date | undefined;
    metas: Meta[] | undefined;
    arquivos: Arquivo[] | undefined;
    setor?: Setor | undefined;
}